import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[NoLeadingWhitespace]',
})
export class NoLeadingWhitespaceValidatorDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const inputValue = this.el.nativeElement.value;

    // Prevent leading whitespace
    if (this.el.nativeElement.selectionStart === 0 && event.key === ' ') {
      event.preventDefault();
    }

    // Prevent form submission if input is empty
    if (event.key === 'Enter' && inputValue.trim() === '') {
      event.preventDefault();
    }
  }
}